import BoilerTable from "./BoilerTable";

export default BoilerTable